<!-- modal loading -->
<button
  #trigLoginLoadingModal
  type="button"
  class="btn d-none"
  data-toggle="modal"
  data-target="#loginLoadingModal">

  aux trigger for login loading modal

</button>


<!-- modal error -->
<button
  #trigLoginErrorModal
  type="button"
  class="btn d-none"
  data-toggle="modal"
  data-target="#loginErrorModal">

  aux trigger for login error modal

</button>


<!-- login form component -->
<div class="login-box login-centered">

  <form
    ngNativeValidate
    #f="ngForm"
    (ngSubmit)="ingresar(f)">


    <!-- RUT -->
    <div class="form-group">

      <div class="input-group login-input">

        <input
          class="form-control"
          type="text"
          name="rut"
          [(ngModel)]="rut"
          placeholder="Ingresa tu RUT"
          (input)="changeRut()"
          autocomplete="username"
          required>

      </div>

    </div>


    <!-- PASSWORD -->
    <div class="form-group">

      <div class="input-group login-input">

        <input
          class="form-control"
          [type]="fieldTextType ? 'text' : 'password'"
          name="password"
          ngModel
          placeholder="Contraseña"
          autocomplete="current-password"
          required>


        <span
          class="input-group-addon"
          (click)="toggleFieldTextType()">

          <i
            class="d-flex"
            [class]="
              fieldTextType
                ? 'fi fi-sr-eye'
                : 'fi fi-sr-eye-crossed'
            ">
          </i>

        </span>

      </div>

    </div>


    <!-- ACCIONES -->
    <div class="login-actions text-center">

      <button
        class="btn btn-submit"
        type="submit"
        name="submit">

        Entrar

      </button>


      <button
        *ngIf="
          loginPaciente &&
          id_typ_user === 2
        "
        type="button"
        class="btn btn-submit"
        data-toggle="modal"
        data-target="#signupModal"
        style="
          font-size:16px !important;
          opacity:0.6;
        ">

        Crea tu cuenta

      </button>


      <button
        type="button"
        class="link-recover-pass"
        data-toggle="modal"
        data-target="#recoveryModal">

        ¿Olvidaste tu contraseña?

      </button>

    </div>

  </form>

</div>